/**
 * Converts a dataUrl to a file
 *
 * @param dataUrl data url of the image
 * @param fileName name for the file
 * @returns A file object
 */
export function dataUrlToFile(dataUrl: string, fileName: string): File {
  // Decode base64 string
  const arr = dataUrl.split(',')
  const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/png'
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], fileName, { type: mime })
}
